import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export function ProtectedRoute({ children, requireAdmin = false, requireEvaluator = false, requireRecruiter = false }) {
  const { user, loading, isAdmin, isEvaluator, isRecruiter } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="label-overline">Loading session…</div>
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  if (requireAdmin && !isAdmin) {
    return <Navigate to="/dashboard" replace />;
  }
  if (requireEvaluator && !isEvaluator) {
    return <Navigate to="/dashboard" replace />;
  }
  if (requireRecruiter && !isRecruiter && !isAdmin) {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
}
